
import React, { useEffect, useState, useRef } from 'react';

interface CounterProps {
    end: number;
    duration?: number;
    prefix?: string;
    suffix?: string;
    className?: string;
}

const Counter: React.FC<CounterProps> = ({ end, duration = 2000, prefix = '', suffix = '', className = '' }) => {
    const [count, setCount] = useState(0);
    const countRef = useRef<HTMLSpanElement>(null);
    const [hasAnimated, setHasAnimated] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !hasAnimated) {
                    setHasAnimated(true);

                    // Better approach: calculate step based on time
                    const startTime = Date.now();

                    const timer = setInterval(() => {
                        const timePassed = Date.now() - startTime;
                        if (timePassed >= duration) {
                            setCount(end);
                            clearInterval(timer);
                            return;
                        }

                        const progress = timePassed / duration;
                        // Ease out quart
                        const ease = 1 - Math.pow(1 - progress, 4);

                        setCount(Math.floor(end * ease));
                    }, 16); // ~60fps

                    observer.disconnect();
                }
            },
            { threshold: 0.5 }
        );

        if (countRef.current) {
            observer.observe(countRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [end, duration, hasAnimated]);

    return (
        <span ref={countRef} className={className}>
            {prefix}{count}{suffix}
        </span>
    );
};

export default Counter;
